import { render, staticRenderFns } from "./20-InstrumentIntro.vue?vue&type=template&id=5c0b6660&scoped=true"
import script from "./20-InstrumentIntro.vue?vue&type=script&lang=ts"
export * from "./20-InstrumentIntro.vue?vue&type=script&lang=ts"
import style0 from "./20-InstrumentIntro.vue?vue&type=style&index=0&id=5c0b6660&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b6660",
  null
  
)

export default component.exports